module.exports = __webpack_public_path__ + "static/media/ArrowMenu.186ba1bc.svg";